import { gql } from '@apollo/client';

export const CREATE_CHAT_ROOM_IF_NOT_EXISTS = gql`
  mutation CreateChatRoom($roomId: String!) {
    createChatRoomIfNotExists(room_id: $roomId)
  }
`;
